var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.985,
    height: 15.297,
    viewBox: "0 0 16.985 15.297",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_84",
    "data-name": "Group 84",
    transform: "translate(-3 -5.575)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_129",
    "data-name": "Group 129"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77",
    "data-name": "Path 77",
    d: "M15.549,14.944A.944.944,0,0,0,14.605,14H8.944A.945.945,0,0,0,8,14.944v1.887h7.549ZM8,18.718h7.549v2.831H8Z",
    transform: "translate(-0.282 -0.677)",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78",
    "data-name": "Path 78",
    d: "M19.985,11.436c0-2.8-1.691-5.861-8.393-5.861S3,8.636,3,11.436v7.549a1.889,1.889,0,0,0,1.887,1.887h.944V14.267a2.834,2.834,0,0,1,2.831-2.831h5.662a2.834,2.834,0,0,1,2.831,2.831v6.605H18.1a1.889,1.889,0,0,0,1.887-1.887Z",
    fill: "#000000"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDock);
export default __webpack_public_path__ + "static/media/dock.579ce645f602b8313cf3edd0c50a98c7.svg";
export { ForwardRef as ReactComponent };